export const IconCopy = '/assets/icons/copy/copy.svg'
export const IconEdit = '/assets/icons/actions/edit.svg'
export const IconDelete = '/assets/icons/actions/delete.svg'
export const IconLink = '/assets/icons/links/link.svg'
export const IconWhatsApp = '/assets/icons/actions/whatsapp.svg'
export const IconEye = '/assets/icons/eyes/eyeButtonBlack.svg'
export const IconClone = '/assets/icons/copy/clone.svg'
export const IconShare = '/assets/icons/share/share.svg'
export const IconDisable = '/assets/icons/actions/cancel.svg'
export const IconEnable = '/assets/icons/actions/checked.svg'
